import { useMemo } from "react";
import useAuth from "@/hooks/useAuth";
import { NoPermissionScreen } from "@/components/screens/shared/NoPermissionScreen";
import NewIncidentPage from "@/components/screens/incident/new";
import { NavigationHistoryProvider } from "@/contexts/NavigationHistoryContext";

export default function NewIncidentRoute() {
  const { userRoles, displayNames } = useAuth();

  const hasIncidentsAccess = useMemo(() => {
    return userRoles?.some((r) => r.permissions?.incidents?.read === true) ?? false;
  }, [userRoles]);

  if (!hasIncidentsAccess) {
    return <NoPermissionScreen entityName={displayNames?.incidents?.plural || "Incidents"} />;
  }

  return (
    <NavigationHistoryProvider>
      <NewIncidentPage />
    </NavigationHistoryProvider>
  );
}
